
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class OrderForPurchaseGrid extends _Ext.GridBase<ECommOrderItemsRow,any> {
        protected getColumnsKey() { return 'ECommerce.OrderItemsForJobWork'; }
        protected getDialogType() { return ECommOrderItemsDialog; }
        protected getIdProperty() { return ECommOrderItemsRow.idProperty; }
        protected getInsertPermission() { return ECommOrderItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommOrderItemsRow.localTextPrefix; }
        protected getService() { return ECommOrderItemsService.baseUrl; }

        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {};
        public rowSelection: Serenity.GridRowSelectionMixin;
        withBom: boolean; 
        //withBom: boolean;
        constructor(container: JQuery,options) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            this.slickGrid.setOptions({ rowHeight: 30 });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): ECommOrderItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        //private getEffectiveValue(item, field): any {
        //    var pending = this.pendingChanges[item.ProductID];
        //    if (pending && pending[field] !== undefined) {
        //        return pending[field];
        //    }

        //    return item[field];
        //}

        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }

    } 
    //@Serenity.Decorators.registerClass()
    //export class ECommOrderItemsSelectGrid extends Serenity.EntityGrid<ECommOrderItemsRow, any> {
    //    protected getColumnsKey() { return 'ECommerce.OrderItems'; }
    //    protected getDialogType() { return ECommOrderItemsDialog; }
    //    protected getIdProperty() { return ECommOrderItemsRow.idProperty; }
    //    protected getInsertPermission() { return ECommOrderItemsRow.insertPermission; }
    //    protected getLocalTextPrefix() { return ECommOrderItemsRow.localTextPrefix; }
    //    protected getService() { return ECommOrderItemsService.baseUrl; }

    //    private autoSize;
    //    private pendingChanges: Q.Dictionary<any> = {};
    //    private rowSelection: Serenity.GridRowSelectionMixin;
    //    withBom: boolean;
    //    static partyid: number;
    //    static InStock: boolean;
    //    protected getColumns() {

    //        var _this = this;
    //        var columns = super.getColumns.call(this);
    //        columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
    //        return columns;
    //    };
    //    //withBom: boolean;
    //    constructor(container: JQuery) {
    //        super(container);
    //        (this.view.params as StockListRequest).PartyId = ECommOrderItemsSelectGrid.partyid;
    //        (this.view.params as StockListRequest).InStock = ECommOrderItemsSelectGrid.InStock;
    //        this.rowSelection = new Serenity.GridRowSelectionMixin(this);
    //        new Serenity.HeaderFiltersMixin({
    //            grid: this
    //        });
    //        return this;
    //    }
    //    protected createSlickGrid(): Slick.Grid {
    //        let grid = super.createSlickGrid();
    //        this.autoSize = new Slick.AutoColumnSize();
    //        grid.registerPlugin(this.autoSize);


    //        return grid;
    //    }
    //    get selectedItems(): ECommOrderItemsRow[] {
    //        var _this = this;
    //        return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
    //    }


    //    protected markupReady() {
    //        super.markupReady();
    //        if (this.autoSize != null) {
    //            this.autoSize.resizeAllColumns();
    //        }
    //    }
    //    //private getEffectiveValue(item, field): any {
    //    //    var pending = this.pendingChanges[item.ProductID];
    //    //    if (pending && pending[field] !== undefined) {
    //    //        return pending[field];
    //    //    }

    //    //    return item[field];
    //    //}

    //    protected getViewOptions() {
    //        var opt = super.getViewOptions();

    //        opt.rowsPerPage = 100;
    //        return opt;
    //    }

    //} 
}